import { Button, Modal } from 'antd'
import useModalShow from '../elements/Hooks/useModalShow'
import React from 'react'

function CustomModalButton(props) {
  const {
    buttonName = 'Click Me',
    title = 'Modal',
    loading = false,
    onSubmit = () => console.log('No Submit Func'),
  } = props
  const { visible, onShow, onCancel } = useModalShow()
  return (
    <div>
      <Button type="primary" loading={loading} onClick={onShow}>
        {buttonName}
      </Button>
      <Modal
        title={title}
        visible={visible}
        onOk={() => {
          onSubmit()
          onCancel()
        }}
        onCancel={onCancel}>
        {props.children}
      </Modal>
    </div>
  )
}

export default CustomModalButton
